import { site_choices_default } from './chunk-SMV7EJNI.mjs';
import { logo_default } from './chunk-5QHANN2W.mjs';
import { ResponsiveAvatar } from './chunk-BI277V2Z.mjs';
import AccountCircle from '@mui/icons-material/AccountCircle';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import { jsx, jsxs } from 'react/jsx-runtime';

var Header = (props) => {
  const { onProfileClick, sites, user } = props;
  const avatarUrl = user == null ? void 0 : user.picture;
  return /* @__PURE__ */ jsx(AppBar, { position: "sticky", color: "default", elevation: 0, children: /* @__PURE__ */ jsxs(Toolbar, { sx: { display: "flex", gap: 2, justifyContent: "space-between" }, children: [
    /* @__PURE__ */ jsxs(
      Box,
      {
        sx: {
          display: "flex",
          alignItems: "center",
          minWidth: "fit-content"
        },
        children: [
          /* @__PURE__ */ jsx(logo_default, {}),
          /* @__PURE__ */ jsx(site_choices_default, { sites, activeSite: "listen" })
        ]
      }
    ),
    /* @__PURE__ */ jsx(Box, { sx: { display: "flex", minWidth: "fit-content" }, children: /* @__PURE__ */ jsx(IconButton, { onClick: onProfileClick, "aria-label": "account options", children: avatarUrl ? /* @__PURE__ */ jsx(ResponsiveAvatar, { src: avatarUrl, alt: user.name, "data-testid": "user-avatar" }) : /* @__PURE__ */ jsx(AccountCircle, {}) }) })
  ] }) });
};

export { Header };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-FM6HLBBS.mjs.map